<script lang="ts">
	import { user_settings } from 'src/stores/account/user';
	import { Button, ButtonGroup, TimePicker } from '@Shelly/shelly-design-system';
	import { createEventDispatcher } from 'svelte';
	import { digitFormat } from 'src/helpers/date_helper';
	import { format } from 'svelte-i18n';

	export let hours, mins;

	const dispatch = createEventDispatcher();

	const usFormat = $user_settings.units.date_format === 'us';
	let min = 0;
	let max = 23;
	let label = '';
	let usFormattedHours = 0;
	let formatedHours = digitFormat(hours);
	let formatedMins = digitFormat(mins);
	let time = `${formatedHours}:${formatedMins}`;

	const translateFromUsToEu = (hours: number, label: string) => {
		if (label === 'AM') {
			return hours === 12 ? 0 : hours;
		}
		return hours === 12 ? 12 : hours + 12;
	};

	const translateFromEuToUs = (hours: number) => {
		return hours % 12 || 12;
	};

	if (usFormat) {
		min = 1;
		max = 12;

		usFormattedHours = translateFromEuToUs(hours);
		label = `${hours >= 12 ? 'P' : 'A'}M`;
	} else {
		usFormattedHours = hours;
	}

	const handleOnChange = (e) => {
		if (usFormat) {
			label =
				(e.detail.direction === 'up' && e.detail.hours === 12) ||
				(e.detail.direction === 'down' && e.detail.hours === 11)
					? label === 'AM'
						? 'PM'
						: 'AM'
					: label;

			hours = translateFromUsToEu(e.detail.hours, label);
			formatedHours = e.detail.formatedHours;
			formatedMins = e.detail.formatedMins;
			time = e.detail.time;

			dispatch('change', {
				...e.detail,
				hours: hours,
			});
		} else {
			hours = e.detail.hours;
			dispatch('change', { ...e.detail });
		}
	};

	const handleLabelChange = (newLabel) => {
		label = newLabel;
		hours = translateFromUsToEu(translateFromEuToUs(hours), label);
		formatedHours = digitFormat(hours);
		formatedMins = digitFormat(mins);
		time = `${hours}:${formatedMins}`;

		dispatch('change', {
			formatedHours,
			formatedMins,
			hours: hours,
			mins,
			time,
		});
	};
</script>

<div class="d-flex justify-content-center align-items-center">
	<TimePicker
		id="timepicker-0yn4m2b"
		a11yProps={{
			timePickerAriaLabel: $format('label_time_picker', { default: 'Time Picker' }),
			increaseButtonAriaLabel: $format('label_increase_button', { default: 'Increase button' }),
			decreaseButtonAriaLabel: $format('label_decrease_button', { default: 'Decrease button' }),
			hourInputAriaLabel: $format('label_hour_input', { default: 'Hour input' }),
			minuteInputAriaLabel: $format('label_minute_input', { default: 'Minute input' }),
		}}
		hours={usFormattedHours}
		{mins}
		hoursRange={{ min, max }}
		on:change={handleOnChange}
	/>
	{#if usFormat}
		<ButtonGroup
			id="buttongroup-ti96p0c"
			aria-label={$format('label_time_picker', { default: 'Time Picker' })}
			class="ml-xs"
			orientation="vertical"
		>
			<Button class={label === 'AM' && 'active'} size="m" on:click={() => handleLabelChange('AM')}
				>AM</Button
			>
			<Button class={label === 'PM' && 'active'} size="m" on:click={() => handleLabelChange('PM')}
				>PM</Button
			>
		</ButtonGroup>
	{/if}
</div>
